const siteConfig = {
  brandName: "suddlecorner",
  wordmark: "suddlecorner",
  website: "https://www.suddlecorner.store",
  companyName: "STARHARBOR TECH LIMITED",
  description:
    "Thoughtful layers for everyday living. Explore textured knitwear, practical outerwear and easy cotton essentials at suddlecorner.",
  tagline: "Everyday layers. Your own way.",
  origin: "Hong Kong",
  currency: {
    code: "USD",
    symbol: "$",
    locale: "en-US",
  },
  shipping: {
    standardRate: 15,
    canadaRate: 28,
    internationalRate: 45,
    freeThreshold: 250,
  },
  returns: {
    windowDays: 14,
  },
  contact: {
    email: "raise@suddlecorner.store",
    phone: "",
    address: "RM03, 24/F, HO KING COMM CTR,2-16 FAYUEN ST, MONG KOK, HONG KONG",
  },
  socialLinks: [],
  navigation: {
    shop: [
      { label: "NEW ARRIVALS", category: "New Arrivals" },
      { label: "WOMEN'S", category: "Women's" },
      { label: "JACKETS", category: "Jackets" },
      { label: "SWEATERS", category: "Sweaters" },
      { label: "SHIRTS", category: "Shirts" },
      { label: "HEAVY DUTY COTTON", category: "Heavy Duty Cotton" },
      { label: "ACCESSORIES", category: "Accessories" },
      { label: "ALL PRODUCTS", category: "All" },
    ],
    about: [
      { label: "OUR COMPANY", to: "/about#retail-store" },
      { label: "OUR STORY", to: "/about#history" },
      { label: "OUR APPROACH", to: "/about#factory" },
      { label: "CONTACT", to: "/contact" },
    ],
    more: [
      { label: "PRIVACY POLICY", to: "/privacy" },
      { label: "COOKIE POLICY", to: "/cookies" },
      { label: "TERMS OF USE", to: "/terms" },
      { label: "FAQS", to: "/faqs" },
      { label: "SHIPPING", to: "/shipping" },
      { label: "RETURNS", to: "/returns" },
    ],
  },
};

export default siteConfig;
